import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import ScrollToTop from "../components/ScrollToTop";
import Home from "../pages/Home";
import About from "../pages/About";
import Sectors from "../pages/Sectors";
import Reports from "../pages/Reports";
import Library from "../pages/Library";
import PageNotFound from "../pages/PageNotFound";
import SingleSectorPage from "../pages/SingleSectorPage";
import SingleArticlePage from "../pages/SingleArticlePage";
import Contact from '../pages/Contact';
import Gallery from "../pages/Gallery";
import Articles from "../pages/Articles";
import TrackerMethodology from "../pages/TrackerMethodology";
import Tracker from "../pages/Tracker";
import TilbTracker from "../pages/TilbTracker";
import Disclaimer from "../pages/Disclaimer";
import Faq from '../pages/Faq'
import { useLocation } from "react-router-dom";



const AppRoutes = () => {
    const VALID_LANGUAGES = ["en", "ar"];
    const location = useLocation();
    const pathSegments = location.pathname.split("/").filter(Boolean);
    const lang = VALID_LANGUAGES.includes(pathSegments[0]) ? pathSegments[0] : null;

    useEffect(() => {
        if (!lang) {
            window.location.replace(`/en${location.pathname.replace(/\/$/, "")}`);
            return;
          }
        localStorage.setItem("language", lang || "en");
        document.documentElement.setAttribute("lang", lang === "ar" ? "ar" : "en");
        document.documentElement.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
        const bootstrap = document.getElementById("bootstrap-link");
        if (lang === 'ar') {
            bootstrap.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.2.0/dist/css/bootstrap.rtl.min.css";
        } else {
            bootstrap.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.2.0/dist/css/bootstrap.min.css";
        }
    }, []);

  return (
    <ScrollToTop>
      <Routes>
        <Route path="/" element={<Navigate to="/en" replace/>} />
        <Route path="/:lang/about" element={<About />} />
        <Route path="/:lang/sectors" element={<Sectors />} />
        <Route exact path="/:lang/sectors/:slug" element={<SingleSectorPage />} />
        <Route path="/:lang/reports" element={<Reports />} />
        <Route path="/:lang/library" element={<Library />} />
        {/* <Route path="/:lang/surveys" element={<Surveys />} /> */}
        <Route path="/:lang/tracker" element={<Tracker />} />
        <Route path="/:lang/tilb-tracker" element={<TilbTracker />} />
        <Route path="/:lang/contact-us" element={<Contact />} />
        <Route path="/:lang/disclaimer" element={<Disclaimer />} />
        <Route path="/:lang/faq" element={<Faq />} />
        <Route path="/:lang/gallery" element={<Gallery />} />
        <Route path="/:lang/tracker-methodology" element={<TrackerMethodology />} />
        <Route path="/:lang/articles" element={<Articles />} />
        <Route exact path="/:lang/articles/:slug" element={<SingleArticlePage />} />
        <Route path="/:lang" element={<Home />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </ScrollToTop>
  );
};

export default AppRoutes;
